export default __webpack_public_path__ + "static/media/01B.050.6d351a97.png";